module.exports = __webpack_public_path__ + "img/ribbon1.b43a106b.png";